import React, { useEffect, useRef, useState } from 'react';

import {Platform, View} from 'react-native';
import Loader from '../Loader/loader';
import WebView from 'react-native-webview';
import { getCleanUrl } from '../../utils/Helper';
import { useCssStyle } from '../../customHook/getCssStyle';
import { handleMessageEventListener } from '../../js/eventListener';
import { useNavigation } from '@react-navigation/native';
import { useDispatch } from 'react-redux';

const IFrameRendererHome = (props) => {
  const {handleOnWidgetClick, listItemData, widget} = props;

  const getStyles = useCssStyle();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const webViewRef = useRef();
  const iframeRef = useRef();

  const navigate = useNavigation();

  useEffect(() => {
    if (Platform.OS === 'web') {
      const handleMessage = (event) => {
        dispatch(handleMessageEventListener(event, iframeRef, navigate));
      };

      window.addEventListener('message', handleMessage);
      setTimeout(() => {
        setLoading(false);
      }, 900);
      
      return () => window.removeEventListener('message', handleMessage);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  

  if (!listItemData?.length) {
    return null;
  } 

  return (
    <View
      style={getStyles([
        'iFrameRendererHomeMainContainer',
        `iFrameRendererHomeMainContainer_${listItemData[0].widgetMetaHtmlId}`,
        `iFrameRendererHomeMainContainer_${listItemData[0].widgetId}`
      ])}
      id={`iFrameRendererHomeMainContainer iFrameRendererHomeContainer_${listItemData[0].widgetMetaHtmlId} iFrameRendererHomeMainContainer_${listItemData[0].widgetId}`}>
      <View
        style={getStyles(['widgetmainContainer', 'iFrameMainContainer'])}
        id="widgetmainContainer iFrameMainContainer">
        {loading && (
          <View
            style={{
              height: '100%',
              justifyContent: 'center',
              alignItems: 'center',
            }}>
            <Loader style={getStyles(['crossOverContaniner_loader'])} />
          </View>
        )}
        {listItemData?.length && listItemData.map((widgetData, index) => {
            const url = getCleanUrl(widgetData?.targetUrl);
            
            return Platform.OS === 'web' ? (
                <iframe
                    ref={iframeRef}
                    src={url}
                    style={getStyles([
                    'widgetmainContainerChildContainer',
                    'iFrameRendererHomeMainContainerChildContainer',
                    `iFrameRendererHome_${widgetData?.widgetMetaHtmlId}`,
                    ])}
                    title={widgetData?.displayName}
                    onLoad={() => setLoading(false)}
                    id={`widgetmainContainerChildContainer iFrameRendererHomeMainContainerChildContainer iFrameRendererHome_${widgetData?.widgetMetaHtmlId}`}
                />
                ) : (
                <WebView
                    ref={webViewRef}
                    originWhitelist={['*']}
                    style={getStyles([
                    'widgetmainContainerChildContainer',
                    'webViewHomeMainContainerChildContainer',
                    `webViewHome_${widgetData?.widgetMetaHtmlId}`,
                    ])}
                    source={{uri: url}}
                    javaScriptEnabled={true}
                    cacheEnabled={true}
                    onLoadEnd={() => setLoading(false)}
                    onMessage={(event)=> dispatch(handleMessageEventListener(event, webViewRef, navigate))}
                />
            )
        })}
      </View>
    </View>
  );
};

export default IFrameRendererHome;
